export default "__VITE_ASSET__DXLwy5dK__"